(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["primeNGDataTableExtensions"] = factory();
	else
		root["primeNGDataTableExtensions"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var string_split_join_1 = __webpack_require__(2);
var PrimeNGDataTableODataQueryExtensions = (function () {
    function PrimeNGDataTableODataQueryExtensions() {
    }
    PrimeNGDataTableODataQueryExtensions.applyLazyLoadEvent = function (query, event) {
        if (event.rows > 0) {
            query = query.Top(event.rows);
        }
        if (event.first > 0) {
            query = query.Skip(event.first);
        }
        if (event.filters) {
            var filterOData = [];
            for (var filterProperty in event.filters) {
                if (event.filters.hasOwnProperty(filterProperty)) {
                    var filter = event.filters[filterProperty];
                    if (filter.matchMode && filter.matchMode !== '') {
                        var params = string_split_join_1.StringUtils.split(filter.matchMode.toLowerCase(), {
                            separatorChar: PrimeNGDataTableODataQueryExtensions.separatorChar,
                            escapeChar: PrimeNGDataTableODataQueryExtensions.escapeChar
                        });
                        var operator = params[0];
                        // Replace Boss.Name by Boss/Name
                        var odataProperty = filterProperty.replace(/\./g, '/');
                        // http://docs.oasis-open.org/odata/odata/v4.0/odata-v4.0-part2-url-conventions.html
                        switch (operator) {
                            case 'day':
                            case 'fractionalseconds':
                            case 'hour':
                            case 'minute':
                            case 'month':
                            case 'second':
                            case 'totaloffsetminutes':
                            case 'totalseconds':
                            case 'year':
                                filterOData.push(operator + "(" + odataProperty + ") " + params[1] + " " + filter.value);
                                break;
                            // Logical Operators
                            case 'eq':
                            case 'ne':
                            case 'gt':
                            case 'ge':
                            case 'lt':
                            case 'le':
                                filterOData.push(odataProperty + " " + operator + " " + filter.value);
                                break;
                            case 'has':
                                throw new Error('Logical Operator "has" is not supported yet!');
                            // String Functions
                            case 'concat':
                                filterOData.push(operator + "(" + odataProperty + ", '" + params[1] + "') " + params[2] + " '" + filter.value + "'");
                                break;
                            case 'contains':
                            case 'endswith':
                            case 'startswith':
                                filterOData.push(operator + "(" + odataProperty + ", '" + filter.value + "')");
                                break;
                            case 'length':
                                filterOData.push(operator + "(" + odataProperty + ") " + params[1] + " " + filter.value);
                                break;
                            case 'substring':
                                // Example: substring:1:eq
                                if (params.length === 3) {
                                    filterOData.push(operator + "(" + odataProperty + ", " + params[1] + ") " + params[2] + " '" + filter.value + "'");
                                }
                                // Example: substring:1:2:eq
                                if (params.length === 4) {
                                    filterOData.push(operator + "(" + odataProperty + ", " + params[1] + ", " + params[2] + ") " + params[3] + " '" + filter.value + "'");
                                }
                                break;
                            default:
                        }
                    }
                }
            }
            if (filterOData.length > 0) {
                query = query.Filter(filterOData.join(' and '));
            }
        }
        var orderings = [];
        var getOrderAsText = function (order) {
            return order && order > 0 ? 'asc' : 'desc';
        };
        if (event.sortField) {
            orderings.push(event.sortField + ' ' + getOrderAsText(event.sortOrder));
        }
        if (event.multiSortMeta) {
            orderings = event.multiSortMeta.map(function (e) { return e.field + ' ' + getOrderAsText(e.order); });
        }
        if (orderings.length > 0) {
            query = query.OrderBy(orderings.join(', '));
        }
        return query;
    };
    return PrimeNGDataTableODataQueryExtensions;
}());
exports.PrimeNGDataTableODataQueryExtensions = PrimeNGDataTableODataQueryExtensions;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(0));


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stringUtils__ = __webpack_require__(3);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "StringUtils", function() { return __WEBPACK_IMPORTED_MODULE_0__stringUtils__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StringUtils; });
var StringUtils = (function () {
    function StringUtils() {
    }
    StringUtils.join = function (strings, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.separatorChar, separatorChar = _c === void 0 ? ':' : _c, _d = _b.escapeChar, escapeChar = _d === void 0 ? '\\' : _d;
        function escapeString(input) {
            return input
                .replace(escapeChar, escapeChar + escapeChar)
                .replace(separatorChar, escapeChar + separatorChar);
        }
        return strings.map(escapeString).join(separatorChar);
    };
    StringUtils.split = function (source, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.separatorChar, separatorChar = _c === void 0 ? ':' : _c, _d = _b.escapeChar, escapeChar = _d === void 0 ? '\\' : _d;
        function unEscapeString(input) {
            return input
                .replace(escapeChar + separatorChar, separatorChar)
                .replace(escapeChar + escapeChar, escapeChar);
        }
        var result = [];
        var segmentStart = 0;
        for (var i = 0; i < source.length; i++) {
            var readEscapeChar = false;
            if (source[i] === escapeChar) {
                readEscapeChar = true;
                i++;
            }
            if (!readEscapeChar && source[i] === separatorChar) {
                result.push(unEscapeString(source.substring(segmentStart, i)));
                segmentStart = i + 1;
            }
            if (i === source.length - 1) {
                result.push(unEscapeString(source.substring(segmentStart)));
            }
        }
        return result;
    };
    return StringUtils;
}());

//# sourceMappingURL=stringUtils.js.map

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// primeng-datatable-extensions.umd.min.js